
export interface FolderFile extends globalThis.File{
	filePath:string;
	folderFilename:string;
}

export interface File extends globalThis.File{
	filePath?:string;
	folderFilename?:string;
}

export function unique(files:Iterable<File>){
	const map=new Map<string,File>();
	for(const file of files){
		const key=JSON.stringify([file.name,file.size,file.type,file.lastModified,file.folderFilename ?? null]);
		if(!map.has(key))
			map.set(key,file);
	}
	return [...map.values()];
}

async function traverseFileTree(entry:FileSystemEntry, path=''):Promise<FolderFile[]>{
	if(entry.isFile){
		const fileEntry=<FileSystemFileEntry>entry;
		const file=await new Promise<FolderFile>(resolve=>fileEntry.file(f=>resolve(<FolderFile>f)));
		file.filePath=path+file.name; //save full path
		file.folderFilename=`${path.replaceAll('/','_')}${file.name}`;
		return [file];
	}

	if(entry.isDirectory){
		const dirEntry=<FileSystemDirectoryEntry>entry;
		const dirReader=dirEntry.createReader();
		let children:FileSystemEntry[]=[];
		let promises: Promise<FolderFile[]>[]=[];
		do{
			children=await new Promise<FileSystemEntry[]>(resolve=>dirReader.readEntries(v=>resolve(v)));
			promises=promises.concat(...children.map(child=>traverseFileTree(child,path+entry.name+'/')));
		}while(children.length>0);
		return (await Promise.all(promises)).flat();
	}
	return [];
}

export async function dataTransferItemsToFilesRecursive(dataTransferItems:DataTransferItemList){
	const entries=Array.from(dataTransferItems).map(v=>v.webkitGetAsEntry());
	const promises=entries.map(e=>traverseFileTree(e));
	const files=(await Promise.all(promises)).flat();
	return files;
}
